import { MeterType } from "@next-platform/packages-ts-types";
/** Overlay snapshot-supplied text onto the levels that hid it in the public view; same array reference when nothing applies. */
const overlayLevels = (levels, revealedLevels) => {
    if (!levels || !revealedLevels?.length) {
        return levels;
    }
    let didChange = false;
    const merged = levels.map((level, index) => {
        const reached = revealedLevels.find((entry) => entry.index === index);
        if (!reached) {
            return level;
        }
        didChange = true;
        return { ...level, label: reached.label, ...(reached.caption !== undefined ? { caption: reached.caption } : {}), revealed: true };
    });
    return didChange ? merged : levels;
};
/**
 * The public view withholds unrevealed level text; the HUD snapshot carries the text of levels the
 * conversation has reached. Merge them so HUD consumers see one `RulebookPublicView`.
 * A snapshot for a different rulebook is ignored — its labels must not leak across rulebooks.
 */
const mergeRevealedLevels = ({ rulebook, snapshot }) => {
    if (!snapshot || snapshot.rulebook_id !== rulebook.id) {
        return rulebook;
    }
    let didChange = false;
    const meters = (rulebook.meters ?? []).map((meter) => {
        const hudMeter = snapshot.meters?.[meter.id];
        if (!hudMeter) {
            return meter;
        }
        const baseLevels = meter.type === MeterType.CLOCK ? meter.day_levels : meter.levels;
        const mergedLevels = overlayLevels(baseLevels, hudMeter.revealed_levels);
        const mergedTodLevels = overlayLevels(meter.tod_levels, hudMeter.revealed_tod_levels);
        if (mergedLevels === baseLevels && mergedTodLevels === meter.tod_levels) {
            return meter;
        }
        didChange = true;
        const next = { ...meter };
        if (mergedLevels && meter.type === MeterType.CLOCK) {
            next.day_levels = mergedLevels;
        }
        else if (mergedLevels) {
            next.levels = mergedLevels;
        }
        if (mergedTodLevels) {
            next.tod_levels = mergedTodLevels;
        }
        return next;
    });
    return didChange ? { ...rulebook, meters } : rulebook;
};
export default mergeRevealedLevels;
